// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1S-PT","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2moDl"};